import * as React from 'react';
import { StarRounded } from '@mui/icons-material';
import {
  StyledBox,
  StyledBoxNotScrollable,
} from '../../favouriteselection/search/Search.styled';
import { StyledChip } from './ChipDisplay.styled';

type ChipDisplayProps = {
  data: string[];
  handleRemoveTeam?: (team: string) => void;
  displayScrollable?: boolean;
};

const ChipDisplay: React.FC<ChipDisplayProps> = ({
  data,
  handleRemoveTeam,
  displayScrollable,
}) => {
  return (
    <>
      {displayScrollable ? (
        <StyledBox>
          {handleRemoveTeam
            ? data.map((data, index) => (
                <StyledChip
                  avatar={<StarRounded color="warning" />}
                  key={data}
                  label={data}
                  onDelete={() => handleRemoveTeam(data)}
                  variant="filled"
                />
              ))
            : data.map((data, index) => (
                <StyledChip
                  avatar={<StarRounded color="warning" />}
                  key={data}
                  label={data}
                  variant="filled"
                />
              ))}
        </StyledBox>
      ) : (
        <StyledBoxNotScrollable>
          {handleRemoveTeam
            ? data.map((data, index) => (
                <StyledChip
                  avatar={<StarRounded />}
                  key={data}
                  label={data}
                  onDelete={() => handleRemoveTeam(data)}
                  variant="filled"
                />
              ))
            : data.map((data, index) => (
                <StyledChip
                  avatar={<StarRounded />}
                  key={data}
                  label={data}
                  variant="filled"
                />
              ))}
        </StyledBoxNotScrollable>
      )}
    </>
  );
};

export default ChipDisplay;
